module.exports = __webpack_public_path__ + "static/img/Scene_graphics@3x.991d81e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Scene_graphics@3x.png
// module id = wpc9
// module chunks = 1